import React from 'react';
import { useTranslation } from 'react-i18next';
import Link from '~/common/components/Link';
import { useAuthenticatedContext } from '~/common/contexts/auth';
import { useEnterprises } from '~/common/contexts/enterprises';
import useEnterpriseCalendarLink from '../../hooks/useEnterpriseCalendarLink';
import styles from './AICreditPurchaseLink.css';

export const DEFAULT_CALENDAR_LINK =
  'https://calendly.com/david-vertin-deque/ai-credit-increase';

const AICreditPurchaseLink: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuthenticatedContext();
  const { activeEnterprise } = useEnterprises();
  const { data: calendarLinkData, loading } = useEnterpriseCalendarLink(
    user.token,
    activeEnterprise?.id || null
  );

  const getCalendarLink = (link: string | null): string => {
    if (!link) {
      return DEFAULT_CALENDAR_LINK;
    }

    try {
      const baseUrl = new URL(link);
      const path = '/ai-credit-increase';
      baseUrl.pathname = baseUrl.pathname.replace(/\/$/, '') + path;
      return baseUrl.toString();
    } catch {
      return DEFAULT_CALENDAR_LINK;
    }
  };

  if (loading) {
    // TODO: We want a proper <Loader> here. See https://github.com/dequelabs/axe-extension/issues/6750.
    return (
      <p className={styles.loading}>
        {t('Loading AI credit purchase link...')}
      </p>
    );
  }

  return (
    <Link
      url={getCalendarLink(calendarLinkData?.calendarLink || null)}
      openInNewTab
      data-testid="ai-credit-purchase-link"
    >
      {t('Purchase additional AI credits')}
    </Link>
  );
};

export default AICreditPurchaseLink;
